import { Wrench } from 'lucide-react';
import PreventiveMaintenancePlanner from './workshop/PreventiveMaintenancePlanner';
import BreakdownResponseHub from './workshop/BreakdownResponseHub';

export default function WorkshopMaintenance() {
  return (
    <section aria-label="Workshop and maintenance" className="space-y-5">
      <div className="border-b border-logi-grid pb-4">
        <div className="mb-2 flex items-center gap-2">
          <div className="flex h-7 w-7 items-center justify-center rounded-lg bg-orange-50 ring-1 ring-orange-500/30">
            <Wrench className="h-4 w-4 text-orange-700" strokeWidth={1.75} />
          </div>
          <span className="text-xs font-semibold uppercase tracking-widest text-orange-700/80">
            OGTS LogiCore™ · Workshop Operations Module
          </span>
        </div>
        <h2 className="text-xl font-bold tracking-tight text-logi-text sm:text-2xl">
          Workshop &amp; Maintenance
        </h2>
        <p className="mt-1 text-sm text-logi-muted">
          Preventive service scheduling · Breakdown response · UAE garage network
        </p>
      </div>

      <PreventiveMaintenancePlanner />
      <BreakdownResponseHub />
    </section>
  );
}
